import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../ui/Layout';
import Card from '../ui/Card';
import Button from '../ui/Button';
import './PaymentResultPage.css';
import { Invoice } from '../../domain/entities/Invoice';
import { Recordatorio } from '../../domain/entities/Recordatorio';

const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const transactionDate = new Date().toLocaleDateString('es-CO');
  const transactionRef = `TX${Date.now()}`;
  const state = location.state as {
    invoice?: Invoice;
    recordatorio?: Recordatorio;
    paymentAmount: number;
    isPartialPayment: boolean;
    paymentMethodUsed: string;
    tipo?: string;
  };
  const { paymentAmount, paymentMethodUsed } = state;
  const isRecordatorio = state.tipo === 'RECORDATORIO';
  const invoice = state.invoice as Invoice;
  const recordatorio = state.recordatorio as Recordatorio;
  
  const handleGoHome = () => {
    navigate('/', { replace: true });
  };
  
  return (
    <Layout>
      <div className="payment-result-container">
        <Card className="payment-result-card">
          <div className="payment-result success">
            <div className="result-icon success-icon">✓</div>
            <h2 style={{ color: 'green' }}>¡Su pago ha sido procesado exitosamente¡</h2>
            
            <div className="transaction-details">
              <p className="reference">Referencia: <strong>{transactionRef}</strong></p>
              <p>Fecha: {transactionDate}</p>
              <p>{isRecordatorio ? 'Número de Recordatorio de pago' : 'Número de Factura'}: {isRecordatorio ? `RDP${recordatorio.nroRecordatorio}` : invoice.invoiceNumber}</p>
              <p>Método de pago: {paymentMethodUsed}</p>
              <p style={{ color: 'red' }}>Valor Pagado: {paymentAmount}</p>
              <p>Estado: <span className="status-success">Aprobado</span></p>
            </div>
            
            <p className="result-message">
            Se ha enviado un comprobante de pago a su correo electrónico registrado.
            </p>
            
            <Button onClick={handleGoHome} fullWidth>
              Volver al Inicio
            </Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default PaymentSuccessPage; 